export const MarketingAttributionsFeatureFlags = {
  enabled: 'enable-marketing-attribution',
};
